import React, {Component} from 'react';
import {Modal} from 'react-bootstrap';
import * as messageConstants from '../../../shared/messages';

class StartUsingNewIdpCertificateModal extends Component {

    handleHideModalStartUsingNewIdpCertificate = () => {
        this.props.handleHideModalStartUsingNewIdpCertificate();
    }
    handleStartUsingNewIdpCertificate = () => {
        this.props.handleStartUsingNewIdpCertificate();
    }

    render() {
        return (
            <div className="action-block">
                <Modal
                    show={this.props.showModalStartUsingNewIdpCertificate}
                    onHide={this.handleHideModalStartUsingNewIdpCertificate}
                    container={this}
                    dialogClassName="new-idp-certificate-modal"
                >
                    <Modal.Header className="new-idp-certificate-modal-header">
                        <Modal.Title className="line-height-for-modal-title">
                            <span className="question-sign-rectangle">
                                <span className="qmark"/>
                            </span>
                            <span className="new-idp-certificate-modal-header-text">{messageConstants.START_USING_NEW_IDP_CERTIFICATE_MODAL_HEADER}</span>
                            <button className="entity-id-modal-close"
                                    type="button"
                                    onClick={this.handleHideModalStartUsingNewIdpCertificate}/>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="new-idp-certificate-modal-body">
                        <div className="modal-text-item-top">
                            {messageConstants.START_USING_NEW_IDP_CERTIFICATE_MODAL_BODY_SECTION_1}
                        </div>
                        <div className="modal-text-item-bottom">
                            {messageConstants.START_USING_NEW_IDP_CERTIFICATE_MODAL_BODY_SECTION_2}
                        </div>
                    </Modal.Body>
                    <Modal.Footer className="new-idp-certificate-modal-footer">
                        <button
                            type="button"
                            className="btn btn-md cancel-use-new-idp-certificate-button"
                            onClick={this.handleHideModalStartUsingNewIdpCertificate}>
                            {messageConstants.CLOSE_BUTTON}
                        </button>
                        <button
                            type="button"
                            className="btn btn-md btn-primary use-new-idp-certificate-button"
                            onClick={this.handleStartUsingNewIdpCertificate}>
                            {messageConstants.USE_NEW_CERTIFICATE_BUTTON}
                        </button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

export default StartUsingNewIdpCertificateModal;